import Link from "next/link";
import { theme } from "antd";
import {
  UnorderedListOutlined,
  AppstoreOutlined,
  SearchOutlined,
  FileTextOutlined,
  LinkOutlined,
  DashboardOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { AnnotatedDeepLink, DeepLinkType } from "pages/api/deep-links/types";
import { Flex } from "./Flex";
import { Typography } from "antd";
import { Condition } from "src/search/types";

interface NavigableDeepLinkProps {
  deepLink: AnnotatedDeepLink<any>;
  orgId: string;
  spanRow?: boolean;
  filters?: Condition[];
}

export const NavigableDeepLink = ({
  deepLink,
  orgId,
  spanRow,
  filters,
}: NavigableDeepLinkProps) => {
  const { token } = theme.useToken();

  const getResourceIcon = (type: DeepLinkType) => {
    switch (type) {
      case DeepLinkType.BOARD: {
        return <DashboardOutlined />;
      }
      case DeepLinkType.EXPLORE: {
        return <SearchOutlined />;
      }
      case DeepLinkType.NARRATIVE: {
        return <FileTextOutlined />;
      }
      case DeepLinkType.DIGEST_2: {
        return <BookOutlined />;
      }
      default: {
        return <LinkOutlined />;
      }
    }
  };

  const getResourcePath = (type: DeepLinkType, id: string) => {
    switch (type) {
      case DeepLinkType.BOARD: {
        return `/${orgId}/boards/${id}`;
      }
      case DeepLinkType.EXPLORE: {
        return `/${orgId}/explore/${id}`;
      }
      case DeepLinkType.NARRATIVE: {
        return `/${orgId}/reports/${id}`;
      }
      case DeepLinkType.DIGEST_2: {
        return `/${orgId}/topics/${id}`;
      }
      default: {
        return "#";
      }
    }
  };

  const IconComponent = getResourceIcon(deepLink.type as DeepLinkType);
  return (
    <Link
      target="_blank"
      href={{
        pathname: getResourcePath(deepLink.type as DeepLinkType, deepLink.id),
        query: {
          orgId,
          id: deepLink.id,
          filters: filters ? JSON.stringify(filters) : undefined,
        },
      }}
      style={{ width: "100%", color: token.colorText }}
    >
      <Flex style={{ justifyContent: "space-between" }}>
        <Typography.Text>{deepLink.name}</Typography.Text>
        <span style={{ color: token.colorIcon }}>{IconComponent}</span>
      </Flex>
    </Link>
  );
};
